module.exports = __webpack_public_path__ + "static/media/location-icon.278b26f6.svg";